import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-canepergroupbycutcar',
  templateUrl: './canepergroupbycutcar.component.html',
  styleUrls: ['./canepergroupbycutcar.component.css']
})
export class CanepergroupbycutcarComponent implements OnInit {
  @ViewChild('table') table: ElementRef;
  Pergroup: UntypedFormGroup;
  constructor(private spinner: NgxSpinnerService) {
    this.Pergroup = new UntypedFormGroup({
      szone: new UntypedFormControl('0'),
      startday: new UntypedFormControl(),
      today: new UntypedFormControl(),
    });
  }

  ngOnInit(): void {
  }
  choosedate = '';
  zonecode: any;

  ExportExcel() {
    let zone = this.Pergroup.get('szone').value;
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, 'ข้อมูลปริมาณอ้อยเข้าหีบสะสมรายกลุ่มรถตัด' + zone + '.xlsx');
  }
  date = { date1: new Date('2024-12-1'), date2: new Date('2025-04-30') }
  dateS = { date1: new Date('2024-12-1'), date2: new Date(Date.now()) }

  sumallbygroup: any[]; // ผลรวมค่า
  bycarcut = [];
  LoadCanebyCutcar() {
    let dateS = this.dateS;
    let date1 = this.date2en(dateS.date1)
    let date2 = this.date2en(dateS.date2);
    this.choosedate = `${this.date2th(dateS.date1)} - ${this.date2th(dateS.date2)}`;
    if (!date1 || !date2) { alert("! กรุณาเลือกวันที่ก่อนค่ะ !") }
    else {
      this.spinner.show();
      let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/exec_f_v?f=[dbQBRD].[dbo].[caneCollectCarCutBydate]&v='${date1}','${date2}'`;
      axios.get(url)
        .then(res => {
          this.bycarcut = (res.data.recordset);
          this.sumdata(this.bycarcut);
          this.spinner.hide();

        }).catch(err => { throw (err) })
    }
  }

  // รวมค่าข้างล่าง
  sumdata(data: any) {
    let allassesscane = (data.map((el: any) => { return parseFloat(el.assess) })).reduce((a, b) => a + b, 0);
    let allcanein = (data.map((el: any) => { return parseFloat(el.canein) })).reduce((a, b) => a + b, 0);
    let pccanein = parseFloat(allcanein) / (parseFloat(allassesscane) / 100);
    let targetcaneinday = (data.map((el: any) => { return parseFloat(el.canetargetDate) })).reduce((a, b) => a + b, 0);
    let caneinday = (data.map((el: any) => { return parseFloat(el.caneindate) })).reduce((a, b) => a + b, 0);
    let pccaneinday = parseFloat(caneinday) / (parseFloat(targetcaneinday) / 100);
    this.sumallbygroup = [{
      'sumarea': (data.map((el: any) => { return parseFloat(el.area) })).reduce((a, b) => a + b, 0),
      'sumassess': (data.map((el: any) => { return parseFloat(el.assess) })).reduce((a, b) => a + b, 0),
      'sumcanein': (data.map((el: any) => { return parseFloat(el.canein) })).reduce((a, b) => a + b, 0),
      'sumcaneleft': (data.map((el: any) => { return parseFloat(el.caneleft) })).reduce((a, b) => a + b, 0),
      'sumcaneindate': (data.map((el: any) => { return parseFloat(el.caneindate) })).reduce((a, b) => a + b, 0),
      'sumcanewaitbrr': (data.map((el: any) => { return parseFloat(el.canewaitbrr) })).reduce((a, b) => a + b, 0),
      'sumcaneinFresh': (data.map((el: any) => { return parseFloat(el.caneinFresh) })).reduce((a, b) => a + b, 0),
      'sumareacuted': (data.map((el: any) => { return parseFloat(el.areacuted) })).reduce((a, b) => a + b, 0),
      'sumyieldCuted': (data.map((el: any) => { return parseFloat(el.yieldCuted) })).reduce((a, b) => a + b, 0),
      'sumcanetargetDate': (data.map((el: any) => { return parseFloat(el.canetargetDate) })).reduce((a, b) => a + b, 0),
      'sumcaneinper': (data.map((el: any) => { return parseFloat(el.canetargetDate) })).reduce((a, b) => a + b, 0),
      'sumpccanein': pccanein,
      'sumpccaneintoday': pccaneinday,
      'sumcaneinchoose': (data.map((el: any) => { return parseFloat(el.canein_be) })).reduce((a, b) => a + b, 0),
      'sumccsinchoose': (data.map((el: any) => { return parseFloat(el.ccs_be) })).reduce((a, b) => a + b, 0) / data.length,
      'sumccs': (data.map((el: any) => { return parseFloat(el.ccs) })).reduce((a, b) => a + b, 0) / data.length,
      'sumassesscuted': (data.map((el: any) => { return parseFloat(el.assesscuted) })).reduce((a, b) => a + b, 0),
      'sumcanePerDay': (data.map((el: any) => { return parseFloat(el.canePerDay) })).reduce((a, b) => a + b, 0),
      'sumcnt_all': (data.map((el: any) => { return parseFloat(el.cnt_all) })).reduce((a, b) => a + b, 0),
    }];
  }

  date2en(date: Date): string {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "2-digit", day: "2-digit"//, hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('sv-SE', options);
  }

  date2th(date: Date): string {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit"//, hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }

}
